<template>
  <!--
        作者：luoyiming
        时间：2020-04-25
        描述：插件中心-首页推送
    -->
  <div class="pb50">
    <el-form size="small" ref="form" :model="form" label-width="100px">
      <el-form-item label="api_id" :rules="[{ required: true, message: ' ' }]" prop="api_id">
        <el-input class="max-w460" v-model="form.api_id" placeholder="" type="text"></el-input>
        <div class="gray">api请求接口id</div>
      </el-form-item>
      <el-form-item label="api_secret" :rules="[{ required: true, message: ' ' }]" prop="api_secret">
        <el-input class="max-w460" v-model="form.api_secret" placeholder="" type="text"></el-input>
        <div class="gray">api请求接口secret</div>
      </el-form-item>

      <!--提交-->
      <div class="common-button-wrapper"><el-button size="small" type="primary" @click="onSubmit" :loading="loading">申请</el-button></div>
    </el-form>

    
  </div>
</template>
<script>
import Api from '@/api/api.js';
export default {
  components: {
  },
  data() {
    return {
      form: {
        api_id:'',
        api_secret: '',
      },
      /*是否加载完成*/
      loading: false,
    };
  },
  created() {
    this.getData();
  },
  methods: {

    /*获取数据*/
    getData() {
      let self = this;
      Api.getData()
        .then(data => {
          self.form = data.data.values;
        })
        .catch(error => {});
    },

    /*提交*/
    onSubmit() {
      let self = this;
      let params = self.form;
      self.loading = true;
      Api.applyData({}, true)
        .then(data => {
          self.loading = false;
          if (data.code == 1) {
            self.$message({
              message: '恭喜你，保存成功',
              type: 'success'
            });
            self.getData();
          }
        })
        .catch(error => {
          self.loading = false;
        });
    },
  }
};
</script>

<style>
.reward-list .reward-item {
  margin-bottom: 10px;
  padding: 10px 20px;
  border: 1px solid #ebeef5;
}

.reward-list .delete-reward {
  position: absolute;
  top: 10px;
  right: 20px;
  cursor: pointer;
  z-index: 10;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/api/app/index.vue